module.exports = __webpack_public_path__ + "assets/images/MicrophonePointerLeft.b8af41afc65dbe861fbabdf0e0a2612b.svg";